import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initI18n } from "@faceheart/i18n";
import { App } from "./App";
import "./index.css";

// Init i18n before any component renders. admin-web only needs the
// common + admin namespaces.
initI18n({ ns: ["common", "admin"] });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
